import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'svg-logo-mrnf',
    templateUrl: './logo-mrnf.component.svg',
    imports: [
        TranslateModule
    ]
})
export class LogoMrnfComponent { }
